<div class="op-detail-card" role="region" aria-label="Datos de la operación">
  <h4 class="op-detail-title">Datos de la operación</h4>

  @for (section of sections(); track $index) {
    <div class="op-detail-section">
      @if (section.title) {
        <h5 class="op-detail-subtitle">{{ section.title }}</h5>
      }
      <div class="op-fields-grid">
        @for (field of section.fields; track field.label) {
          <div class="op-field" [class.is-full]="field.fullWidth">
            <span class="op-label">{{ field.label }}</span>
            <div class="op-value" [class.op-value--obs]="field.fullWidth">{{ field.value }}</div>
          </div>
        }
      </div>
    </div>
  }
</div>
